export const initialState = {
  columns: [
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'Name',
      align: 'left',
    },
    {
      id: 'fileType',
      numeric: false,
      disablePadding: true,
      label: 'Type',
      align: 'left',
    },
    {
      id: 'lastModified',
      numeric: false,
      disablePadding: true,
      label: 'Last modified',
      align: 'center',
    },
    {
      id: 'actions',
      numeric: false,
      disablePadding: true,
      label: '',
    },
  ],
  statuses: {
    loading: false,
    value: [],
  },
  states: {
    loading: false,
    value: [],
  },
  types: {
    loading: false,
    value: [],
  },
  salesMethods: {
    loading: false,
    value: [],
  },
  organizations: {
    loading: false,
    value: [],
  },
  allProperties: {
    initialised: false,
    offset: 0,
    loading: true,
    hasMore: false,
    value: [],
  },
  autocompleteProperties: {
    offset: 0,
    loading: true,
    hasMore: false,
    value: [],
  },
  myProperties: {
    loading: true,
    value: [],
  },
  searchProperties: {
    offset: 0,
    loading: false,
    hasMore: false,
    value: [],
  },
  selectedProperty: null,
  newPropertyForm: {
    loading: false,
  },
  editPropertyForm: {
    loading: false,
  },
  files: {
    loading: true,
    value: [],
  },
  currentProperty: null,
};
